var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-product-list"},[_c('ol',{staticClass:"text-base"},_vm._l((_vm.medicines),function(medicine,i){return _c('li',{key:i},[_vm._v(" "+_vm._s(_vm.getMedicineDisplayName(medicine.displayName))+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }